export default __webpack_public_path__ + "static/tgs-logo-black-c1352f11d29319d1aa86a3b42edcf282.png";